<button
    mat-icon-button
    (click)="onClick($event)"
    [color]="color()"
    [disableRipple]="true"
    class="hasnt-ripple"
    [attr.aria-label]="ariaLabel() | translate"
    [matTooltip]="ariaLabel() | translate"
>
    <ng-content></ng-content>
    <mat-icon
        [svgIcon]="splashIcon()"
        [class.mat-icon-rtl-mirror]="rtlMirrorIcon()"
        class="splash-icon"
        [@splash]="state"
    ></mat-icon>
</button>
